var map = {
	"./涡轮/worm_cylinder_left.prt.jpg": "048c",
	"./涡轮/worm_cylinder_right.prt.jpg": "f689",
	"./涡轮/worm_gear_cylinder_left.prt.jpg": "5ee25",
	"./涡轮/worm_gear_cylinder_right.prt.jpg": "f29e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b73";